import { render, staticRenderFns } from "./AllRegistration.vue?vue&type=template&id=d9cf93f6"
import script from "./AllRegistration.vue?vue&type=script&lang=js"
export * from "./AllRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports